const messageBundle = {
    fileUploadModal:{
        textMessages:{
            uploadHospitalDataMsg1: "Upload Hospital Data (xlsx or xls)",
            uploadHospitalDataMsg2: "Add hospital details easily by uploading an excel file",
            uploadHospitalDataMsg3: 'Ensure your file follows the correct format for a smooth upload',
            uploadSpectacleRequestMessage: "Upload Spectacle Details (xlsx or xls)",
            uploadSpectacleRequestImportMessage: "Update Spectacle details easily by uploading a file ",
        },
        labels:{
            upLoadCSV:"Upload File",
        }
        
    }
 
    
    // Add more messages here as needed
};
 
export default messageBundle;
 